import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import emailjs from "@emailjs/browser";
import { db } from "../firebase";
import { collection, addDoc, Timestamp, doc, updateDoc,setDoc } from "firebase/firestore";
import { getDoc, arrayUnion } from "firebase/firestore";



export default function ReportUserModal({ isOpen, onClose, user }) {
  const [reason, setReason] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  const reasons = [
    "Spam",
    "Contenido inapropiado",
    "Acoso o bullying",
    "Información falsa",
    "Otro",
  ];

  const wordCount = customReason.trim().split(/\s+/).filter(Boolean).length;

  const handleSendReport = async () => {
  if (!reason || !user) return;

  const wordCount = customReason.trim().split(/\s+/).filter(Boolean).length;
  if (reason === "Otro" && wordCount > 200) {
    setError("El texto personalizado no puede exceder las 200 palabras.");
    return;
  }

  setSending(true);
  setError(null);

  const reportData = {
    reported_user_name: user.nombre || user.name || "Desconocido",
    reported_user_uid: user.uid || "Sin UID",
    reason: reason === "Otro" ? customReason : reason,
    timestamp: Timestamp.now(),
  };

  try {
    // --- Enviar email ---
    await emailjs.send(
      "service_0gzaryb",
      "template_lo413fn",
      {
        ...reportData,
        timestamp: new Date().toLocaleString(),
      },
      "rzHKDWT7d_ZRaDbA7"
    );

    // --- Guardar reporte en Firestore ---
    await addDoc(collection(db, "AccountsReports"), reportData);

    // --- Guardar notificación en NotificationsAdminHistory ---
    const notificationsRef = doc(db, "NotificationsAdminHistory", "ReportesUsuarios");
    const newNotification = {
      title: "Nuevo reporte de usuario",
      message: `${reportData.reported_user_name} (${reportData.reported_user_uid}) fue reportado por: "${reportData.reason}"`,
      timestamp: Timestamp.now(),
      type: "reporte_usuario",
      read: false,
      details: reportData,
    };

    const docSnap = await getDoc(notificationsRef);
    if (docSnap.exists()) {
      await updateDoc(notificationsRef, {
        notifications: arrayUnion(newNotification),
      });
    } else {
      await setDoc(notificationsRef, { notifications: [newNotification] });
    }

    // --- Reset y cerrar modal ---
    setReason("");
    setCustomReason("");
    onClose();
  } catch (err) {
    console.error("Error al enviar el reporte o guardar la notificación:", err);
    setError("Hubo un problema al enviar el reporte. Intenta de nuevo.");
  } finally {
    setSending(false);
  }
};


  if (!user) return null;

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-40 overflow-y-auto" onClose={onClose}>
        <div className="min-h-screen px-4 text-center bg-black/30">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="inline-block w-full max-w-md p-6 my-20 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
              <Dialog.Title className="text-lg font-bold text-gray-900 mb-4">
                Reportar a: {user.nombre || user.name || "Desconocido"}
              </Dialog.Title>

              <div className="space-y-3">
                {reasons.map((r) => (
                  <label key={r} className="block">
                    <input
                      type="radio"
                      name="reportReason"
                      value={r}
                      checked={reason === r}
                      onChange={() => {
                        setReason(r);
                        setError(null);
                      }}
                      className="mr-2"
                    />
                    {r}
                  </label>
                ))}

                {reason === "Otro" && (
                  <div>
                    <textarea
                      value={customReason}
                      onChange={(e) => setCustomReason(e.target.value)}
                      placeholder="Describe el motivo del reporte (máx. 200 palabras)"
                      className="w-full border border-gray-300 rounded p-2 mt-2"
                      rows={4}
                    />
                    <p className="text-sm text-gray-600 mt-1">
                      {wordCount}/200 palabras
                    </p>
                  </div>
                )}
              </div>

              {error && <p className="text-red-500 mt-4">{error}</p>}

              <div className="mt-6 flex justify-end space-x-3">
                <button
                  className="px-4 py-2 rounded border border-gray-300 hover:bg-gray-100"
                  onClick={onClose}
                  disabled={sending}
                >
                  Cancelar
                </button>
                <button
                  disabled={
                    !reason ||
                    sending ||
                    (reason === "Otro" && (wordCount === 0 || wordCount > 200))
                  }
                  className={`px-4 py-2 rounded text-white ${
                    !reason || (reason === "Otro" && wordCount === 0)
                      ? "bg-red-300 cursor-not-allowed"
                      : "bg-red-600 hover:bg-red-700"
                  }`}
                  onClick={handleSendReport}
                >
                  {sending ? "Enviando..." : "Enviar reporte"}
                </button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
